import { render, staticRenderFns } from "./holiday-message.vue?vue&type=template&id=4fa4f2c9&scoped=true&"
import script from "./holiday-message.vue?vue&type=script&lang=js&"
export * from "./holiday-message.vue?vue&type=script&lang=js&"
import style0 from "./holiday-message.vue?vue&type=style&index=0&id=4fa4f2c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4f2c9",
  null
  
)

export default component.exports